import React, { forwardRef } from 'react'
import { LatLngExpression, Map } from 'leaflet'
import { MapContainer } from 'react-leaflet'
import MapTileLayer from '@/javascript/presentation/components/maps/map-tile-layer'
import FullscreenControl from '@/javascript/presentation/components/maps/fullscreen-control'
import MarkerClusterGroup from 'react-leaflet-cluster'
import Container from '@mui/material/Container'
import { MemberMarker, WorkMarker, MapSubtitle } from './components'
import { UserLocation } from '@/javascript/domain/entities/maps/user-location'
import { WorkLocation } from '@/javascript/domain/entities/maps/work-location'

type MapBoxProps = {
  locations: {
    works: WorkLocation[]
    users: UserLocation[]
    center: LatLngExpression
    bounds: L.LatLngBounds | null
  }
}

const MapBox = forwardRef<Map, MapBoxProps>(({ locations }, ref) => {
  return (
    <>
      <MapView ref={ref} locations={locations} />
      <Container sx={{ justifyItems: 'flex-start' }} data-testid="map-box">
        <MapSubtitle />
      </Container>
    </>
  )
})

export default MapBox

const MapView = forwardRef<Map, MapBoxProps>(({ locations: { center, works, users } }, ref) => {
  return (
    <MapContainer center={center} zoom={13} scrollWheelZoom={true} ref={ref}>
      <MapTileLayer />
      <FullscreenControl />
      <MarkerClusterGroup chunkedLoading spiderfyDistanceMultiplier={1.25}>
        {works.map(location => (
          <WorkMarker
            key={`work-marker-${location.id}`}
            workId={location.id}
            position={[location.latitude, location.longitude]}
            workStatus={location.status}
            workTitle={location.description}
            locationName={location.hierarchyName}
            isLate={location.isLate}
          />
        ))}
        {users.map(location => (
          <MemberMarker
            key={`user-marker-${location.id}`}
            position={[location.latitude, location.longitude]}
            memberName={location.name}
            memberEmail={location.email}
            datetime={location.lastSeenAt}
            accuracy={location.accuracy}
            maxAccuracy={location.maxAccuracy}
            imageUrl={location.photoUrl}
          />
        ))}
      </MarkerClusterGroup>
    </MapContainer>
  )
})
